import { IFavoriteParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export let RecentlyViewedObjectType = {
  View: 'view',
  Workbook: 'workbook',
  Metric: 'metric',
  PublishedConnection: 'publishedConnection'
};

export class MarkRecentlyViewedRequest extends Request<IFavoriteParams, IResult> {
  constructor(params: IFavoriteParams) {
    super('markRecentlyViewed', params);
  }
}
